import { GenData, QSingle } from '@educraft/base';
import { Fraction, SimpleGenSingle } from '../../genEq/genHelper';

export const Fractions = {
  additionDifferent:
    (max: number) =>
    (data: GenData): QSingle => {
      const r = data.random;
      const arr = r.NN(4, 1, max);
      const a = Fraction.create(arr[0], arr[1]);
      const b = Fraction.create(arr[2], arr[3]);
      return { texts: [`${a} + ${b} =`], answer: Fraction.add(a, b).simplify().toNumber() };
    },

  additionSame:
    (max: number) =>
    (data: GenData): QSingle => {
      const r = data.random;
      const arr = r.NN(3, 1, max);
      const a = Fraction.create(arr[1], arr[0]);
      const b = Fraction.create(arr[2], arr[0]);
      return { texts: [`${a} + ${b} =`], answer: Fraction.add(a, b).simplify().toNumber() };
    },

  subtractionDifferent:
    (max: number) =>
    (data: GenData): QSingle => {
      const r = data.random;
      const arr = r.NN(4, 1, max);
      let a = Fraction.create(arr[0], arr[1]);
      let b = Fraction.create(arr[2], arr[3]);

      if (a.a * b.b < b.a * a.b) {
        const temp = a;
        a = b;
        b = temp;
      }

      return { texts: [`${a} - ${b} =`], answer: Fraction.subtract(a, b).simplify().toNumber() };
    },

  subtractionSame:
    (max: number) =>
    (data: GenData): QSingle => {
      const r = data.random;
      const arr = r.NN(3, 1, max);
      let a = Fraction.create(arr[1], arr[0]);
      let b = Fraction.create(arr[2], arr[0]);

      if (a.a < b.a) {
        const temp = a;
        a = b;
        b = temp;
      }

      return { texts: [`${a} - ${b} =`], answer: Fraction.subtract(a, b).simplify().toNumber() };
    },

  multiplication:
    (max: number) =>
    (data: GenData): QSingle => {
      const r = data.random;
      const arr = r.NN(4, 1, max);
      const a = Fraction.create(arr[0], arr[1]);
      const b = Fraction.create(arr[2], arr[3]);
      return { texts: [`${a} · ${b} =`], answer: Fraction.multiply(a, b).simplify().toNumber() };
    },

  division:
    (max: number) =>
    (data: GenData): QSingle => {
      const r = data.random;
      const arr = r.NN(4, 1, max);
      const a = Fraction.create(arr[0], arr[1]);
      const b = Fraction.create(arr[2], arr[3]);
      return { texts: [`${a} : ${b} =`], answer: Fraction.divide(a, b).simplify().toNumber() };
    },
};

export class Math_Fractions__Addition__10 extends SimpleGenSingle {
  constructor() {
    super(Fractions.additionDifferent(10), 'Math_Fractions__Addition__10');
  }
}
export class Math_Fractions__Addition__10_SameDenominator extends SimpleGenSingle {
  constructor() {
    super(Fractions.additionSame(10), 'Math_Fractions__Addition__10_SameDenominator');
  }
}
export class Math_Fractions__Subtraction__10 extends SimpleGenSingle {
  constructor() {
    super(Fractions.subtractionDifferent(10), 'Math_Fractions__Subtraction__10');
  }
}
export class Math_Fractions__Subtraction__10_SameDenominator extends SimpleGenSingle {
  constructor() {
    super(Fractions.subtractionSame(10), 'Math_Fractions__Subtraction__10_SameDenominator');
  }
}
export class Math_Fractions__Multiplication__10 extends SimpleGenSingle {
  constructor() {
    super(Fractions.multiplication(10), 'Math_Fractions__Multiplication__10');
  }
}
export class Math_Fractions__Division__10 extends SimpleGenSingle {
  constructor() {
    super(Fractions.division(10), 'Math_Fractions__Division__10');
  }
}
